import { Button, Card, Stack, Text } from '@grovus/design-system'
import type { Dict } from '../i18n'

/**
 * Which nothing this is.
 *
 * Four states, told apart in this order, because they call for four different things from
 * the reader and only one of them is about the data:
 *
 * - `company`: no ad account is connected at all. Nothing to show and no tiles either,
 *   because tiles at zero would imply an account that spent nothing
 * - `selection`: every account was deselected. No request was made, so there is nothing to
 *   report; the way out is the account control
 * - `creatives`: accounts in scope, nothing delivered in the window. The tiles render at
 *   zero, which is true
 * - `filtered`: the reader's own filters or floor left nothing. The tiles keep describing
 *   the segment, because they always do
 *
 * `onChangePeriod` gives `creatives` its way out, the period control. The shell passes it
 * only while it holds bounds for the selection on screen, so a missing callback means no
 * button rather than a button that cannot open anything.
 */
export type EmptyKind = 'company' | 'selection' | 'creatives' | 'filtered'

export function EmptyState({ kind, t, onChangePeriod }: { kind: EmptyKind; t: Dict; onChangePeriod?: () => void }) {
  const text: Record<EmptyKind, string> = {
    company: t.emptyCompany,
    selection: t.emptySelection,
    creatives: t.emptyNoCreatives,
    filtered: t.emptyFiltered,
  }
  return (
    <Card p="lg" data-testid="creatives-empty" data-empty={kind}>
      <Stack gap="sm" align="flex-start">
        <Text size="md">{text[kind]}</Text>
        {kind === 'creatives' && onChangePeriod !== undefined && (
          <Button variant="default" onClick={onChangePeriod} data-testid="creatives-empty-change-period">
            {t.changePeriod}
          </Button>
        )}
      </Stack>
    </Card>
  )
}
